(function () {
  const STORAGE_KEY = 'im_breadcrumb_collection';
  const SALE_STATE_CACHE_KEY = 'im_breadcrumb_sale_state_cache';

  function saleState(value) {
    if (value === true || value === 1) return 'true';
    if (value === false || value === 0) return 'false';
    if (value === null || value === undefined || value === '') return 'empty';

    const normalized = String(value).toLowerCase().trim();
    if (normalized === 'true' || normalized === '1') return 'true';
    if (normalized === 'false' || normalized === '0') return 'false';
    return 'empty';
  }

  function readJsonScript(selector) {
    const element = document.querySelector(selector);
    if (!element) return null;

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      return null;
    }
  }

  function getCollectionPath(pathname) {
    const match = (pathname || window.location.pathname).match(/\/collections\/[^/?#]+/);
    return match ? match[0] : null;
  }

  function readSaleStateCache() {
    try {
      return JSON.parse(sessionStorage.getItem(SALE_STATE_CACHE_KEY) || '{}');
    } catch (error) {
      return {};
    }
  }

  function writeSaleStateCache(handle, state) {
    if (!handle) return;
    const cache = readSaleStateCache();
    cache[handle] = state;
    sessionStorage.setItem(SALE_STATE_CACHE_KEY, JSON.stringify(cache));
  }

  function isOnlineSaleHandle(handle) {
    return !!(handle && handle.indexOf('online-sale-') === 0);
  }

  function canStoreOnPlp(config) {
    if (!config) return false;
    if (config.forceStore === true) return true;
    if (config.resolvedSaleState === 'true') return true;
    return saleState(config.saleCollectionMetafield) === 'true';
  }

  function canRestoreStoredBreadcrumb(stored) {
    if (!stored || !stored.url || !stored.title) return false;
    if (stored.forceStore === true) return true;
    if (stored.saleCollectionMetafield === 'true') return true;
    return isOnlineSaleHandle(stored.handle);
  }

  function resolveCollectionSaleState(handle, liquidState) {
    const liquidResolved = saleState(liquidState);

    if (liquidResolved === 'true' || liquidResolved === 'false') {
      writeSaleStateCache(handle, liquidResolved);
      return Promise.resolve(liquidResolved);
    }

    const state = isOnlineSaleHandle(handle) ? 'true' : 'false';
    writeSaleStateCache(handle, state);
    return Promise.resolve(state);
  }

  function initStore() {
    const config = readJsonScript('[data-im-breadcrumb-store]');
    if (!config || !config.enabled) return;

    if (config.forceStore === true) {
      config.resolvedSaleState = 'true';
      writeSaleStateCache(config.handle, 'true');
    }

    const resolvedStatePromise = config.forceStore === true
      ? Promise.resolve('true')
      : resolveCollectionSaleState(config.handle, config.saleCollectionMetafield).then(function (state) {
          config.resolvedSaleState = state;
          return state;
        });

    function rememberCollection(productHandle) {
      const payload = {
        handle: config.handle,
        url: window.location.pathname + window.location.search,
        title: config.pageTitle || config.title,
        pageHandle: config.pageHandle || config.handle,
        productHandle: productHandle,
        saleCollectionMetafield: 'true',
        forceStore: config.forceStore === true,
      };
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    }

    function handleProductLink(event) {
      const link = event.target.closest('a[href*="/products/"]');
      if (!link) return;

      const grid = document.getElementById('product-grid');
      if (grid && !grid.contains(event.target)) return;

      const match = link.pathname.match(/\/products\/([^/?#]+)/);
      if (!match) return;

      if (canStoreOnPlp(config)) {
        rememberCollection(match[1]);
        return;
      }

      if (config.resolvedSaleState === 'false') return;
      if (event.type !== 'click') return;

      event.preventDefault();
      resolvedStatePromise.then(function (state) {
        config.resolvedSaleState = state;
        if (state === 'true') {
          rememberCollection(match[1]);
        }
        window.location.href = link.href;
      });
    }

    document.addEventListener('pointerdown', handleProductLink, true);
    document.addEventListener('click', handleProductLink, true);
  }

  function initPdp() {
    if (window.__imBreadcrumbPdpInit) return;

    const config = readJsonScript('[data-im-breadcrumb-pdp]');
    if (!config) return;

    window.__imBreadcrumbPdpInit = true;

    function setLinkLabel(link, title) {
      const label = link.querySelector('span');
      if (label) label.textContent = title;
      else link.textContent = title;
    }

    function applyDefault(link) {
      if (!config.defaultLink || !config.defaultLink.url) return;
      link.href = config.defaultLink.url;
      link.removeAttribute('data-sale-collection');
      setLinkLabel(link, config.defaultLink.title);
    }

    function applySale(link, url, title) {
      link.href = url;
      link.dataset.saleCollection = 'true';
      setLinkLabel(link, title);
    }

    function getStoredBreadcrumb() {
      try {
        return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      } catch (error) {
        return null;
      }
    }

    function prioritizeCollections(collections, storedHandle) {
      const list = collections.slice();
      list.sort(function (a, b) {
        if (storedHandle) {
          if (a.handle === storedHandle) return -1;
          if (b.handle === storedHandle) return 1;
        }
        if (isOnlineSaleHandle(a.handle) && !isOnlineSaleHandle(b.handle)) return -1;
        if (!isOnlineSaleHandle(a.handle) && isOnlineSaleHandle(b.handle)) return 1;
        return 0;
      });
      return list;
    }

    function findOnlineSaleCollection(collections) {
      for (let i = 0; i < collections.length; i++) {
        if (isOnlineSaleHandle(collections[i].handle)) {
          return collections[i];
        }
      }
      return null;
    }

    function resolveSaleBreadcrumb() {
      if (config.productHasSaleTag !== 'true') {
        return Promise.resolve(null);
      }

      const stored = getStoredBreadcrumb();

      if (stored && stored.productHandle === config.productHandle && canRestoreStoredBreadcrumb(stored)) {
        return Promise.resolve({ url: stored.url, title: stored.title });
      }

      const onlineSaleCollection = findOnlineSaleCollection(config.collections || []);
      if (onlineSaleCollection) {
        return Promise.resolve({
          url: onlineSaleCollection.url,
          title: onlineSaleCollection.title,
        });
      }

      return resolveFromCollections(stored && stored.handle ? stored.handle : null);
    }

    function resolveFromCollections(preferredHandle) {
      const collections = prioritizeCollections(config.collections || [], preferredHandle);
      const cache = readSaleStateCache();
      let chain = Promise.resolve(null);

      collections.forEach(function (collection) {
        chain = chain.then(function (result) {
          if (result) return result;

          const cachedState = cache[collection.handle];
          if (cachedState === 'true') {
            return { url: collection.url, title: collection.title };
          }

          if (cachedState === 'false') return null;

          return resolveCollectionSaleState(collection.handle, collection.saleCollectionMetafield).then(function (state) {
            if (state === 'true') {
              return { url: collection.url, title: collection.title };
            }
            return null;
          });
        });
      });

      return chain;
    }

    function applyPdpBreadcrumb() {
      const link = document.getElementById('js-breadcrumb-collection');
      if (!link) return;

      resolveSaleBreadcrumb().then(function (saleBreadcrumb) {
        if (saleBreadcrumb) {
          applySale(link, saleBreadcrumb.url, saleBreadcrumb.title);
          return;
        }

        applyDefault(link);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyPdpBreadcrumb);
    } else {
      applyPdpBreadcrumb();
    }
  }

  function boot() {
    initStore();
    initPdp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
